import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VoucherServiceService } from '../../voucher-service.service';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StripServiceService } from '../../services/strip-service.service';
import { VenueServiceeService } from '../../services/venue-service/venue-servicee.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { FormControl, Validators } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';
import {NgSelectModule, NgOption} from '@ng-select/ng-select';
RecaptchaComponent.prototype.ngOnDestroy = function() {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.css'],
  animations: [
    trigger('flyInOut', [
      // state('in', style({transform: 'translateY(0)'})),
      transition('void => *', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('800ms 0.8s')
      ]),
      transition('* => void', [
        animate(800, style({ transform: 'translateY(100%)' }))
      ])
    ])
  ]
})
export class VouchersComponent implements OnInit {
  hash: string;
  orgHash: string;
  isOrgSetting: boolean;
  orgSetting: any;
  venues: any[];
  vouchers: any[];
  modalIstance: any;
  stripeHandle: any;
  paymentRequest: any;
  element: any;
  quickPay: any;
  currentVoucher: any;
  buyerDetails: any;
  isSubmit: boolean;
  paymentStep: number;
  heading: string;
  category: string;
  venueSetting: any;
  form: any;
  cardNumberElement: any;
  cardExpiryElement: any;
  cardCVCElement: any;
  cardEntered: any;
  switchToggle: boolean;
  emailValue: string;
  nameValue: string;
  remailValue: string;
  rnameValue: string;
  disablePayment: boolean;
  defaultImage: string;
  @ViewChild('tcsModal') tcsModal: ElementRef;
  @ViewChild('emailConfModal') emailConfModal: ElementRef;
  @ViewChild('successModal') successModalRef: ElementRef;
  @ViewChild('pageView') pageView: ElementRef;
  @ViewChild('myRecaptcha') myRecaptcha: RecaptchaComponent;
  lazyloadOptions: any = {
    offset: 100,
    defaultSquareImg: 'https://s3-ap-southeast-2.amazonaws.com/vectron-join-app/joinapp/venue/3/image.png?1529463638',
    defaultBannerImg: 'http://placehold.it/1200x375'
  };
  openValueCtrl: FormControl;

  config: any = {
    lazy: true,
    grabCursor: true,
   // centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    spaceBetween: 41,
    slidesPerView: 4,
    breakpoints: {
      1150: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
        centeredSlides: true,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    }
  };
  alerts: any[];
  captchaRes: boolean;
  isTcagreed: boolean;
  isEmailConfirmed: boolean;
  readOnlyFields: boolean;
  formData: any;
  pmodalIstance: NgbModalRef;
  curencySymbol: any;
  curencyName: any;
  taxAdded: any;
  recipientEmail: string;
  constructor(
    private router: ActivatedRoute,
    private voucherSer: VoucherServiceService,
    private modalService: NgbModal,
    private stripe: StripServiceService,
    private venue: VenueServiceeService,
    private mySpinner: Ng4LoadingSpinnerService,
    private toastr: ToastrService,
    public activeModal: NgbActiveModal
  ) {
    this.venueSetting = {};
    this.quickPay = { status: false, applePay: false, googlePay: false };
    this.switchToggle = false;
    this.emailValue = '';
    this.nameValue = '';
    this.remailValue = '';
    this.rnameValue = '';
    this.taxAdded = {
      category: { inclusiveTaxes: [], exclusiveTaxes: [] },
      processingFee: { inclusiveTaxes: [], exclusiveTaxes: [] }
    };
    this.disablePayment = false;
    this.isEmailConfirmed = false;
    this.recipientEmail = '';
    this.isOrgSetting = false;
    this.orgSetting = null;
    this.defaultImage = 'https://s3-ap-southeast-2.amazonaws.com/vectron-join-app/joinapp/bepoz-logo.png';
  }
  currencyOptions = {
    align: 'right',
    allowNegative: false,
    allowZero: true,
    decimal: '.',
    precision: 2,
    prefix: '$',
    suffix: '',
    thousands: ','
};
  ngOnInit() {
    // subscribe to route chnage
    this.router.paramMap.subscribe(p => {
      // console.log('route changed: ', p['params']['cate']);

      // fetch/refresh venueSetting
      this.venueSetting = this.router.snapshot.data['venueSettings'];
      this.curencySymbol = this.venueSetting.currency_sign? this.venueSetting.currency_sign : '$';
      this.curencyName = this.venueSetting.currency? this.venueSetting.currency : 'AUD';
      // fetch/refresh hash
      this.hash = this.router.snapshot.queryParams['v_id'];
      if (this.router.snapshot.queryParams['v_id']) {
        this.hash = this.router.snapshot.queryParams['v_id'];
        if (this.venueSetting.setting.value) {
          /*
          --primary-color: #35434B;
          --spl-font-color: #e5e5e5;
          --pg-bg: #0F0F0F;
          --color: #fff;
          --btn-bg: #35434B;
          --btn-fontc: #fff;
          --btn-border: #35434B;
          --btn-font: 20px;
          --btn-activebg: #fff ;
          --btn-activef: #35434B;
          --btn-activebrd: #35434B;
          */
          document.documentElement.style.setProperty('--pg-bg', this.venueSetting.setting.value.background_color ,'important'); //set primary value
          let primaryColor = this.venueSetting.setting.value.primary_colour ? this.venueSetting.setting.value.primary_colour : '#35434B';
          document.documentElement.style.setProperty('--primary-color', primaryColor ,'important');
           //set primary value
          let splFontColor = this.venueSetting.setting.value.title_font_color ? this.venueSetting.setting.value.title_font_color : '#fff';
          document.documentElement.style.setProperty('--spl-font-color', splFontColor ,'important'); //set spl/title color
          document.documentElement.style.setProperty('--color', this.venueSetting.setting.value.font_color ,'important'); // pg font color
          let btnBg = this.venueSetting.setting.value.button_background ? this.venueSetting.setting.value.button_background : '#35434B';
          document.documentElement.style.setProperty('--btn-bg', btnBg ,'important'); //set button bg
          let button_font = this.venueSetting.setting.value.button_font ? this.venueSetting.setting.value.button_font : '#ffffff';
          document.documentElement.style.setProperty('--btn-fontc', button_font ,'important'); //set font colour
          document.documentElement.style.setProperty('--btn-border', this.venueSetting.setting.value.button_border ,'important'); //set border
          document.documentElement.style.setProperty('--btn-activebg', this.venueSetting.setting.value.button_active_bg ,'important'); //set active bg
          document.documentElement.style.setProperty('--btn-activef', this.venueSetting.setting.value.button_active_font ,'important'); //set active font
          document.documentElement.style.setProperty('--btn-activebrd', this.venueSetting.setting.value.button_active_border ,'important'); //set active brd
          let navFontColor = this.venueSetting.setting.value.title_font_color ? this.venueSetting.setting.value.title_font_color : '#ffffff';
          document.documentElement.style.setProperty('--nav-font-color', navFontColor ,'important'); //set nav font
        }
      } else if (this.router.snapshot.queryParams['org_id']) {
        this.orgHash = this.router.snapshot.queryParams['org_id'];
        this.orgSetting = this.router.snapshot.data['venueSettings'];
        this.venueSetting = null;
        this.isOrgSetting = true;
        if (this.orgSetting.image) {
          this.defaultImage = this.orgSetting.image;
        }
        console.log(this.orgSetting.venues)
        if (this.orgSetting.venues.length > 0) {
          this.orgSetting.venues = this.orgSetting.venues.filter( ven => ven.active );
          document.documentElement.style.setProperty('--pg-bg', this.orgSetting.background_color ,'important'); //set primary value
          document.documentElement.style.setProperty('--primary-color', this.orgSetting.primary_colour ,'important'); //set primary value
          document.documentElement.style.setProperty('--spl-font-color', this.orgSetting.title_font_color ,'important'); //set spl/title color
          document.documentElement.style.setProperty('--color', this.orgSetting.font_color ,'important'); // pg font color
          document.documentElement.style.setProperty('--btn-bg', this.orgSetting.button_background ,'important'); //set button bg
          document.documentElement.style.setProperty('--btn-fontc', this.orgSetting.button_font ,'important'); //set font colour
          document.documentElement.style.setProperty('--btn-border', this.orgSetting.button_border ,'important'); //set border
          document.documentElement.style.setProperty('--btn-activebg', this.orgSetting.button_active_bg ,'important'); //set active bg
          document.documentElement.style.setProperty('--btn-activef', this.orgSetting.button_active_font ,'important'); //set active font
          document.documentElement.style.setProperty('--btn-activebrd', this.orgSetting.button_active_border ,'important'); //set active brd
          document.documentElement.style.setProperty('--nav-font-color', this.orgSetting.title_font_color ,'important'); //set nav font
        } else {
          this.orgSetting.venues = [];
        }
      }
      this.currencyOptions.prefix = this.curencySymbol;

      // get category
      switch (p['params']['cate']) {
        case 'gift':
          this.category = 'gift_certificate';
          this.heading = 'Gift Certificate';
          break;
        case 'ticket':
          this.category = 'ticket';
          this.heading = 'Ticket';
          break;
        default:
          this.category = 'voucher';
          this.heading = 'Promotion';
          break;
      }
      if (!this.isOrgSetting) {
        this.voucherSer.getVouchers(this.hash, this.category).subscribe(s => {
          this.vouchers = s['data'];
        });
      }

    }, e => {
      // console.log(e);
      this.toastr.error(e.error.message, '', {
        positionClass: 'toast-center-center'
      });
    });

  }
  toggleOption() {
    if (this.switchToggle === true) {
        this.switchToggle = false;
        this.remailValue = '';
        this.rnameValue = '';
        this.readOnlyFields = false;
    } else {
        this.remailValue = this.emailValue;
        this.rnameValue = this.nameValue;
        this.switchToggle = true;
        this.readOnlyFields = true;
    }
}
  isFree(unit_price) {
    if (Number(unit_price) > 0) {
      return false;
    }

    return true;
  }

  openModal(content, voucher) {
    this.currentVoucher = voucher;
    this.currentVoucher.qty = 1;
    // if an open value gift certificate
    if (this.currentVoucher.is_open_value) {
      this.currentVoucher.unit_price = Number(this.currentVoucher.min_value);
      this.currentVoucher.gift_value = Number(this.currentVoucher.min_value);
      let validatorsOptions: any[] = [
        Validators.required,
        Validators.min(Number(this.currentVoucher.min_value))
      ];
      if (Number(this.currentVoucher.max_value) > Number(this.currentVoucher.min_value)) {
        validatorsOptions = [...validatorsOptions, Validators.max(Number(this.currentVoucher.max_value))];
      }
      this.openValueCtrl = new FormControl(Number(this.currentVoucher.min_value), validatorsOptions);
      this.openValueCtrl.setValue(this.currentVoucher.unit_price);

      this.openValueCtrl.valueChanges.subscribe(newValue => {
        // console.log(newValue);
        this.currentVoucher.unit_price = this.openValueCtrl.value;
        this.currentVoucher.gift_value = this.openValueCtrl.value;
      });
    }
    this.disablePayment = false;
    let cssClass = this.isOrgSetting ? 'org-window' : 'voucher-modal-container';
    cssClass += (this.venueSetting && this.venueSetting.theme) === 'square' ? ' square-edge' : '';
    console.log(cssClass)
    this.modalIstance = this.modalService.open(content, { size: 'lg', centered: true, backdrop : 'static',
    keyboard : false, windowClass: cssClass });
    // console.log(this.modalIstance);

  }

  // venue modal
  openVenueModal(content, venue) {
    this.hash = venue.token;
    this.venueSetting = venue;
    this.mySpinner.show();
    this.voucherSer.getVouchers(this.hash, this.category).subscribe(s => {
      this.vouchers = s['data'];
      this.mySpinner.hide();
      if (this.vouchers.length > 0) {
        this.orgSelectVoucher(this.vouchers[0]);
        let cssClass = this.isOrgSetting ? 'org-window' : 'voucher-modal-container';
        cssClass += (this.orgSetting && this.orgSetting.theme) === 'square' ? ' square-edge' : '';
        this.modalIstance = this.modalService.open(content, { size: 'lg', centered: true, backdrop : 'static',
        keyboard : false, windowClass: cssClass });
      } else {
        this.toastr.error('New Vouchers will be available very soon!', venue.name , {
            positionClass: 'toast-center-center'
          });
      }
    }, error => {
      console.log(error);
      this.mySpinner.hide();
    });
  }

  orgSelectVoucher(voucher) {
    this.currentVoucher = voucher;
    this.currentVoucher.qty = 1;
    // if an open value gift certificate
    if (this.currentVoucher.is_open_value) {
      this.currentVoucher.unit_price = Number(this.currentVoucher.min_value);
      this.currentVoucher.gift_value = Number(this.currentVoucher.min_value);
      let validatorsOptions: any[] = [
        Validators.required,
        Validators.min(Number(this.currentVoucher.min_value))
      ];
      if (Number(this.currentVoucher.max_value) > Number(this.currentVoucher.min_value)) {
        validatorsOptions = [...validatorsOptions, Validators.max(Number(this.currentVoucher.max_value))];
      }
      this.openValueCtrl = new FormControl(Number(this.currentVoucher.min_value), validatorsOptions);
      this.openValueCtrl.setValue(this.currentVoucher.unit_price);

      this.openValueCtrl.valueChanges.subscribe(newValue => {
        // console.log(newValue);
        this.currentVoucher.unit_price = this.openValueCtrl.value;
        this.currentVoucher.gift_value = this.openValueCtrl.value;
      });
    }
    this.disablePayment = false;
  }
  openBuyModal(modalRef) {
    this.stripe.validateOrder(this.hash, this.currentVoucher).subscribe(s => {
      const check_max_qty = s.total_purchased + this.currentVoucher.qty;
      if ((this.currentVoucher.max_limit_per_day !=0 && check_max_qty > this.currentVoucher.max_limit_per_day) && this.currentVoucher.is_unlimited==0){
          this.mySpinner.hide();
          const errorMsg = `Voucher ${this.currentVoucher.title} has closed (sold out)! Only \
          ${this.currentVoucher.max_limit_per_day} items per day`;
          this.toastr.error(errorMsg, '', {
            positionClass: 'toast-center-center'
          });
        } else {
            this.mySpinner.hide();
            this.modalIstance.close();
            let cssClass = this.isOrgSetting ? 'org-window' : 'voucher-modal-container';
            cssClass += (this.orgSetting && this.orgSetting.theme) === 'square' ? ' square-edge' : '';
            this.modalIstance = this.modalService.open(modalRef, { size: 'lg', centered: true, backdrop : 'static',
            keyboard : false, windowClass: cssClass });
            this.modalIstance.result.then((result) => {
            }, (reason) => {
              this.switchToggle = false;
              this.remailValue = '';
              this.rnameValue = '';
              this.readOnlyFields = false;
            });
            }
      }, e => {
        this.mySpinner.hide();
        this.toastr.error(e.error.message, '', {
          positionClass: 'toast-center-center'
        });
      });

  }

  successModal(modalRef) {
    this.modalIstance.close();
    this.switchToggle = false;
    this.remailValue = '';
    this.rnameValue = '';
    this.readOnlyFields = false;
    this.isEmailConfirmed = false;
    this.recipientEmail = '';
    let cssClass = this.isOrgSetting ? 'org-window' : 'voucher-modal-container';
    cssClass += (this.orgSetting && this.orgSetting.theme) === 'square' ? ' square-edge' : '';
    this.modalIstance = this.modalService.open(modalRef, { size: 'sm', centered: true, backdrop : 'static',
    keyboard : false, windowClass: cssClass });
  }

  updateValue(isPlus) {
    if (isPlus > 0) {
      this.openValueCtrl.setValue(this.openValueCtrl.value + isPlus);
      return;
    }
    if (this.currentVoucher.unit_price + isPlus >= Number(this.currentVoucher.min_value)) {
      this.openValueCtrl.setValue(this.openValueCtrl.value + isPlus);
    }
  }

  updateQty(isPlus) {
    if (isPlus > 0) {
      const currentVoucher = this.currentVoucher;
      // this.currentVoucher.qty++; return;
      if (currentVoucher.max_limit_per_transaction > 0 && currentVoucher.qty < currentVoucher.max_limit_per_transaction ) {
        this.currentVoucher.qty++; return;
      } else if (currentVoucher.max_limit_per_transaction === 0) {
        this.currentVoucher.qty++; return;
      } else {
        const errorMsg = `Unable to purchase voucher (${this.currentVoucher.title}). \
        Only ${currentVoucher.max_limit_per_transaction} per transaction.`;
        this.toastr.error(errorMsg, '', {
          positionClass: 'toast-center-center'
        });
        return;
      }
    }
    if (this.currentVoucher.qty > 1) { this.currentVoucher.qty--; }
  }

  getBgImg() {
    return this.venueSetting.use_background_image ? this.venueSetting.background_image : '';
  }

  stripeSuccess(token: string, formValue: any) {
    // console.log(token);
    this.mySpinner.show();
    this.stripe.buyVoucher(this.hash, token['id'], formValue, this.currentVoucher).subscribe(s => {
      // console.log(s);
      this.mySpinner.hide();
      this.successModal(this.successModalRef);
    }, e => {
      this.mySpinner.hide();
      // console.log(e.error.message);
      this.toastr.error(e.error.message, '', {
        positionClass: 'toast-center-center'
      });

    }
    );

  }

  processStripePayment(intentId: any, intentStatus: any, secret: any, action: any) {
    this.mySpinner.show();
    if (intentStatus === 'requires_action') {
        this.stripeHandle.handleCardAction(secret).then((result) => {
          this.mySpinner.show();
            if (result.hasOwnProperty('error')) {
                this.mySpinner.hide();
                this.disablePayment = false;
                let responseError = 'Error processing your payment request, please try again';
                if (result.error.hasOwnProperty('message')) {
                    responseError = result.error.message;
                }
                this.toastr.error(responseError, '', {
                  positionClass: 'toast-center-center'
                });
            }
            if (result.hasOwnProperty('paymentIntent')) {
              this.disablePayment = true;
              this.mySpinner.show();
                this.stripe.confirmPaymentIntent(intentId, result.paymentIntent, this.hash, this.venueSetting.stripe_test_mode)
                .then((success) => {
                    this.mySpinner.hide();
                    if (action) {
                      action('success');
                    }
                    // Reset tax
                    this.taxAdded = {
                      category: { inclusiveTaxes: [], exclusiveTaxes: [] },
                      processingFee: { inclusiveTaxes: [], exclusiveTaxes: [] }
                    };
                    this.disablePayment = false;
                    this.successModal(this.successModalRef);
                    console.log(success);
                }, (error) => {
                  this.disablePayment = false;
                    this.mySpinner.hide();
                    if (error.hasOwnProperty('error')) {
                      error = error.error;
                    }
                    if (action) {
                      action('fail');
                    }
                    let responseError = 'Error processing your payment request, please try again';
                    if (error.hasOwnProperty('message')) {
                        responseError = error.message;
                    }
                    this.toastr.error(responseError, '', {
                      positionClass: 'toast-center-center'
                    });
                });
            }
        });
    } else {
      this.mySpinner.show();
        this.stripeHandle.retrievePaymentIntent(secret).then((result) => {
            if (result.hasOwnProperty('error')) {
                this.mySpinner.hide();
                this.disablePayment = false;
                let responseError = 'Error processing your payment request, please try again';
                if (result.error.hasOwnProperty('message')) {
                    responseError = result.error.message;
                }
                this.toastr.error(responseError, '', {
                  positionClass: 'toast-center-center'
                });
            }
            if (result.hasOwnProperty('paymentIntent')) {
                this.stripe.confirmPaymentIntent(intentId, result.paymentIntent, this.hash, this.venueSetting.stripe_test_mode)
                .then((success) => {
                    this.mySpinner.hide();
                    // Reset tax
                    this.taxAdded = {
                      category: { inclusiveTaxes: [], exclusiveTaxes: [] },
                      processingFee: { inclusiveTaxes: [], exclusiveTaxes: [] }
                    };
                    this.successModal(this.successModalRef);
                    console.log(success);
                    if (action) {
                      action('success');
                    }
                }, function(error) {
                    this.mySpinner.hide();
                    this.disablePayment = false;
                    if (action) {
                      action('fail');
                    }
                    if (error.hasOwnProperty('error')) {
                      error = error.error;
                    }
                    let responseError = 'Error processing your payment request, please try again';
                    if (error.hasOwnProperty('message')) {
                        responseError = error.message;
                    }
                    this.toastr.error(responseError, '', {
                      positionClass: 'toast-center-center'
                    });
                });
            }
        });
    }
    // this.disablePayment = false; // Payment processing in progress, so safe to disable now
  }

  async submitPayment() {
    this.disablePayment = true;
    let recipientName = this.readOnlyFields ? 'myself' : this.buyerDetails.recipient_full_name;
    const cardData = {
      payment_method_id: null,
      data: JSON.stringify([this.currentVoucher]),
      buyer_full_name: this.buyerDetails.buyer_full_name,
      buyer_email: this.buyerDetails.buyer_email,
      recipient_full_name: recipientName,
      recipient_email: this.buyerDetails.recipient_email,
      comment: this.buyerDetails.comment,
      hash: this.hash
    };

    if (this.cardEntered.number && this.cardEntered.expiry && this.cardEntered.cvc) {
        this.mySpinner.show();
        this.stripeHandle.createPaymentMethod( {
            type: 'card',
            card: this.cardNumberElement
        }).then(result  => {
            if (result.hasOwnProperty('error')) {
                this.mySpinner.hide();
                let responseError = 'Error processing your payment request, please try again';
                if (result.error.hasOwnProperty('message')) {
                    responseError = result.error.message;
                }
                this.toastr.error(responseError, '', {
                  positionClass: 'toast-center-center'
                });
                this.disablePayment = false;
            }
            if (result.hasOwnProperty('paymentMethod')) {
                cardData.payment_method_id = result.paymentMethod.id;
                this.stripe.createPaymentIntent(cardData, this.venueSetting.stripe_test_mode).then( success => {
                  // process success payment here
                  console.log(success);
                  this.processStripePayment(success.token, success.payment_intent_status, success.client_secret, null);
                }, error => {
                  // handle errors
                  this.mySpinner.hide();
                  this.disablePayment = false;
                  if (error.hasOwnProperty('error')) {
                    error = error.error;
                  }
                  let responseError = 'Error processing your payment request, please try again';
                  if (error.hasOwnProperty('message')) {
                      responseError = error.message;
                  }
                  this.toastr.error(responseError, '', {
                    positionClass: 'toast-center-center'
                  });
                });
            }
        });
    } else {
        const displayError = document.getElementById('card-input-error');
        let desc = !this.cardEntered.number ? 'number' : '';
        desc = desc + (!this.cardEntered.number ? ', ' : '' + !this.cardEntered.expiry ? 'expiry' : '');
        desc = desc + (!this.cardEntered.number || !this.cardEntered.expiry ? ' and ' : '' + !this.cardEntered.cvc ? 'CVC' : '');
        displayError.textContent = `Please fill the card ${desc}`;
        this.disablePayment = false;
        setTimeout(() => {
            displayError.textContent = '';
        }, 2000);
    }
  }
  // Process Apple Pay and Google Pay
  processQuickPay(paymentMethod, action) {
    let recipientName = this.readOnlyFields ? 'myself' : this.buyerDetails.recipient_full_name;
    const cardData = {
      payment_method_id: paymentMethod.id,
      data: JSON.stringify([this.currentVoucher]),
      buyer_full_name: this.buyerDetails.buyer_full_name,
      buyer_email: this.buyerDetails.buyer_email,
      recipient_full_name: recipientName,
      recipient_email: this.buyerDetails.recipient_email,
      comment: this.buyerDetails.comment,
      hash: this.hash
    };
    this.mySpinner.show();
    this.stripe.createPaymentIntent(cardData, this.venueSetting.stripe_test_mode).then( success => {
      // process success payment here
      this.processStripePayment(success.token, success.payment_intent_status, success.client_secret, action);
    }, error => {
      // handle errors
      this.mySpinner.hide();
      if (error.hasOwnProperty('error')) {
        error = error.error;
      }
      let responseError = 'Error processing your payment request, please try again';
      if (error.hasOwnProperty('message')) {
          responseError = error.message;
      }
      this.toastr.error(responseError, '', {
        positionClass: 'toast-center-center'
      });
    });
  }

  // Added a function to expand it to support tax system
  getAmount(option: string) {
    let total = Number(this.currentVoucher.unit_price) * this.currentVoucher.qty;
    if ( option === 'total') {
      // Check for exclusive tax on vouchers
      if (this.taxAdded.category.exclusiveTaxes.length > 0) {
        this.taxAdded.category.exclusiveTaxes.forEach( tax => {
          total += tax.amount;
        });
      }
      if (this.venueSetting.hasOwnProperty('enable_processing_fee') && this.venueSetting.enable_processing_fee) {
        // Percentage credit card
        if (this.venueSetting.hasOwnProperty('credit_card_fee_percent') && parseFloat(this.venueSetting.credit_card_fee_percent) > 0) {
          const percentageAmount = total * parseFloat(this.venueSetting.credit_card_fee_percent) * 0.01;
          total = total + percentageAmount;
        }
        // Fixed amount
        if (this.venueSetting.hasOwnProperty('credit_card_fee_amount') && parseFloat(this.venueSetting.credit_card_fee_amount) > 0) {
          total = total + parseFloat(this.venueSetting.credit_card_fee_amount);
        }

        // Check for exclusive tax on processing fee
        if (this.taxAdded.processingFee.exclusiveTaxes.length > 0) {
          this.taxAdded.processingFee.exclusiveTaxes.forEach( tax => {
            total += tax.amount;
          });
        }
      }

      return total;
    } else if (option === 'subtotal') {
      return total;
    } else if (option === 'processingfee' && this.venueSetting.enable_processing_fee) {
      // Check for exclusive tax on vouchers
      if (this.taxAdded.category.exclusiveTaxes.length > 0) {
        this.taxAdded.category.exclusiveTaxes.forEach( tax => {
          total += tax.amount;
        });
      }
      let processingFee = parseFloat(this.venueSetting.credit_card_fee_amount);
      if (this.venueSetting.hasOwnProperty('credit_card_fee_percent') && parseFloat(this.venueSetting.credit_card_fee_percent) > 0) {
        processingFee += total * parseFloat(this.venueSetting.credit_card_fee_percent) * 0.01;
      }

      return processingFee;
    }
  }

  voucherTC() {
    this.openTCModal(this.tcsModal);
    return true;
  }

  confirmEmailAddress(form, modalRef) {
    if (this.venueSetting.hasOwnProperty('use_confirmation_popup') && this.venueSetting.use_confirmation_popup) {
      this.recipientEmail = form.value.recipient_email;
      let cssClass = this.isOrgSetting ? 'org-window' : 'voucher-modal-container';
      cssClass += (this.orgSetting && this.orgSetting.theme) === 'square' ? ' square-edge' : '';
      this.pmodalIstance = this.modalService.open(this.emailConfModal,
        { centered: true, windowClass: cssClass, backdrop: true });
        this.pmodalIstance.result.then((data) => {
          if (data === 'confirm') {
            this.isEmailConfirmed = true;
            this.checkCaptcha(form, modalRef);
          } else {
            this.activeModal.dismiss();
          }
        }, (reason) => {
          console.log('cancel');
        });
    } else {
      this.isEmailConfirmed = true;
      this.checkCaptcha(form, modalRef);
    }
  }

  checkCaptcha(form: any, modalRef) {
    this.formData = form;
    if (this.isEmailConfirmed) {
      if (this.venueSetting.hasOwnProperty('enable_voucher_term_conditions') && this.venueSetting.enable_voucher_term_conditions){
      this.openTCModal(this.tcsModal);
      } else {
        this.pay(modalRef, this.formData);
        this.pmodalIstance.close();
      }
    } else {
      this.confirmEmailAddress(form, modalRef);
    }
  }

  okCaptcha(modalRef) {
    this.pay(modalRef, this.formData);
    this.pmodalIstance.close();
  }

  openTCModal(modalRef: ElementRef) {
    this.alerts = [];
    this.captchaRes = false;
    this.isTcagreed = false;
    let cssClass = this.isOrgSetting ? 'org-window tc-window' : 'voucher-modal-container tc-window';
    cssClass += (this.orgSetting && this.orgSetting.theme) === 'square' ? ' square-edge' : '';
    this.pmodalIstance = this.modalService.open(modalRef, { centered: true, backdrop: true, size: 'lg',
      windowClass: cssClass });
  }

  pay(modalRef, form) {
    this.disablePayment = true;
    this.buyerDetails = this.formData.value;
    const total = Number(this.currentVoucher.unit_price) * 100 * this.currentVoucher.qty;
    if (total / 100 > 0) {
      this.stripeHandle = this.stripe.initStripe(
        this.venueSetting
      );
      this.paymentRequest = this.stripe.generatePaymentRequest(this.venueSetting, total);
      this.paymentRequest.on('paymentmethod', async (ev) => {
        console.log(this);
        const recipientName = this.readOnlyFields ? 'myself' : this.buyerDetails.recipient_full_name;
        const cardData = {
          payment_method_id: ev.paymentMethod.id,
          data: JSON.stringify([this.currentVoucher]),
          buyer_full_name: this.buyerDetails.buyer_full_name,
          buyer_email: this.buyerDetails.buyer_email,
          recipient_full_name: recipientName,
          recipient_email: this.buyerDetails.recipient_email,
          comment: this.buyerDetails.comment,
          hash: this.hash
        };
        this.mySpinner.show();
        this.stripe.createPaymentIntent(cardData, this.venueSetting.stripe_test_mode).then( success => {
          // process success payment here
          this.processStripePayment(success.token, success.payment_intent_status, success.client_secret, ev.complete);
        }, error => {
          // handle errors
          this.mySpinner.hide();
          if (error.hasOwnProperty('error')) {
            error = error.error;
          }
          let responseError = 'Error processing your payment request, please try again';
          if (error.hasOwnProperty('message')) {
              responseError = error.message;
          }
          this.toastr.error(responseError, '', {
            positionClass: 'toast-center-center'
          });
        });
      });
      this.paymentRequest.on('cancel', function(ev) {
        console.log('payment cancelled');
      });
      this.mySpinner.show();
      // Check for Apple Pay and Google Pay
      this.paymentRequest.canMakePayment().then( result => {
        this.mySpinner.hide();
        this.disablePayment = false;
        if (result) {
          this.quickPay.status = true;
          if (result.hasOwnProperty('applePay') && result.applePay) {
            this.quickPay.applePay = result.applePay;
            setTimeout(() => {
              const button = document.getElementById('apple-pay-button');
              button.addEventListener('click', this.paymentRequest.show);
              button.querySelector('.applepay').setAttribute('display', 'inline');
            }, 100);
          } else {
            this.quickPay.googlePay = true;
            setTimeout(() => {
              const button = document.getElementById('google-pay-button');
              button.addEventListener('click', this.paymentRequest.show);
            }, 100);
          }
        } else {
          this.quickPay = { status: false, applePay: false, googlePay: false };
        }
      });
      this.element = this.stripeHandle.elements();
      this.processTax();
      // open credit card details instance
      this.modalIstance.close();
      let cssClass = 'payment-modal-container';
      cssClass += (this.orgSetting && this.orgSetting.theme) === 'square' ? ' square-edge' : '';
      this.modalIstance = this.modalService.open(modalRef, { size: 'sm', centered: true, backdrop : 'static',
      keyboard : false, windowClass: cssClass
      + (this.isOrgSetting ? ' org-theme' : '') });
      // Stripe Card detsils elements
      const cssOption = {
        showIcon: true,
          style: {
              base: {
                  fontWeight: 500,
                  fontSize: '16px',
              }
          },
      };
      this.cardNumberElement = this.element.create('cardNumber', cssOption);
      this.cardExpiryElement = this.element.create('cardExpiry', cssOption);
      this.cardCVCElement = this.element.create('cardCvc', cssOption);
      this.cardEntered = { number: false, expiry: false, cvc: false };
      this.cardNumberElement.mount('#card-number-element');
      this.cardExpiryElement.mount('#card-expiry-element');
      this.cardCVCElement.mount('#card-cvc-element');
      this.cardNumberElement.on('change', (event) =>  {
        const displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
            this.cardEntered.number = false;
        } else {
            displayError.textContent = '';
            this.cardEntered.number = true;
        }
      });
      this.cardExpiryElement.on('change',  (event) => {
          const displayError = document.getElementById('card-errors');
          if (event.error) {
              displayError.textContent = event.error.message;
              this.cardEntered.expiry = false;
          } else {
              displayError.textContent = '';
              this.cardEntered.expiry = true;
          }
      });
      this.cardCVCElement.on('change',  (event) => {
          const displayError = document.getElementById('card-errors');
          if (event.error) {
              displayError.textContent = event.error.message;
              this.cardEntered.cvc = false;
          } else {
              displayError.textContent = '';
              this.cardEntered.cvc = true;
          }
          //mthis.$apply();
      });
    } else {
      this.mySpinner.show();
      let recipientName = this.readOnlyFields ? 'myself' : this.buyerDetails.recipient_full_name;
      let formData = form.value;
      formData.recipient_full_name = recipientName;
      this.stripe.buyVoucher(this.hash, '', formData, this.currentVoucher).subscribe(s => {
        // console.log(s);
        this.mySpinner.hide();
        this.successModal(this.successModalRef);
      }, e => {
        this.mySpinner.hide();
        // console.log(e.error.message);
        this.toastr.error(e.error.message, '', {
          positionClass: 'toast-center-center'
        });

      }
      );
    }
  }

  @HostListener('window:popstate')
  onPopstate() {
    console.log('window:popstate');
  }

  closeModal(modal: NgbModalRef) {
    this.remailValue = '';
    this.rnameValue = '';
    this.switchToggle = false;
    this.readOnlyFields = false;
    this.modalIstance.close('close');
    // clear tax
    this.taxAdded = {
      category: { inclusiveTaxes: [], exclusiveTaxes: [] },
      processingFee: { inclusiveTaxes: [], exclusiveTaxes: [] }
    };
  }

  emailchange(changetype) {
    if (this.readOnlyFields) {
      if (changetype) {
        this.remailValue = this.emailValue;
      } else {
        this.emailValue = this.remailValue;
      }
    }
       
  }

  /* Check Tax availability
  * Tax not applied to Gift Certificates
  * Tax applied to processing fee
  */
  processTax() {
    const total = Number(this.currentVoucher.unit_price) * this.currentVoucher.qty;
    if (this.currentVoucher.category !== 'gift_certificate') {
      if (this.currentVoucher.hasOwnProperty('taxes') && this.currentVoucher.taxes.length > 0) {
        this.currentVoucher.taxes.forEach( tax => {
          if (tax.inclusive) {
            tax.amount = total * parseFloat(tax.rate) / (100 + parseFloat(tax.rate));
            this.taxAdded.category.inclusiveTaxes.push(tax);
          } else {
            tax.amount = total * parseFloat(tax.rate) * 0.01;
            this.taxAdded.category.exclusiveTaxes.push(tax);
          }
        });
      }
    }
    if (this.venueSetting.enable_processing_fee && this.currentVoucher.category !== 'gift_certificate') {
      const processingFeetax = this.venueSetting.taxes.find(x => x.tax_rate_num === 1);
      const cardFee = this.getAmount('processingfee');
      if (processingFeetax) {
        if (processingFeetax.inclusive) {
          processingFeetax.amount = cardFee * parseFloat(processingFeetax.rate) / (100 + parseFloat(processingFeetax.rate));
          this.taxAdded.processingFee.inclusiveTaxes.push(processingFeetax);
        } else {
          processingFeetax.amount = cardFee * parseFloat(processingFeetax.rate) * 0.01;
          this.taxAdded.processingFee.exclusiveTaxes.push(processingFeetax);
        }
      }
    }
  }
}
